import React from 'react';
import { useSelector } from 'react-redux';
import { Alert, Snackbar, Typography } from '@mui/material';
import { getCloningOperations, getShouldShowCloningToast } from 'store/app/appSelectors';

const CloningProgressToast: React.FC = () => {
  const shouldShowToast = useSelector(getShouldShowCloningToast);
  const cloningOperations = useSelector(getCloningOperations);

  if (!shouldShowToast) {
    return null;
  }

  const count = cloningOperations.length;
  const message = count === 1 ? 'Cloning inspection in background...' : `Cloning ${count} inspections in background...`;

  return (
    <Snackbar
      open={shouldShowToast}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          minWidth: 'auto',
        },
      }}
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{
          backgroundColor: '#2a2d35',
          color: 'white',
          '& .MuiAlert-icon': {
            color: 'white',
          },
        }}
      >
        <Typography variant="body2">{message}</Typography>
      </Alert>
    </Snackbar>
  );
};

export default CloningProgressToast;
